import { Pipe, PipeTransform } from '@angular/core';
import { FileToUpload } from '@zero/shared/util-models';

@Pipe({
  name: 'uploadInProgress',
  standalone: true,
})
export class UploadInProgressPipe implements PipeTransform {
  public transform(files: FileToUpload[]): boolean {
    return files?.some((file) => file.uploadInProgress);
  }
}
